/*
 * https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 * This is MLP email address Regular Expression.
 *
 * Usage:
 *    import { EMAIL } from './validators.expressions';
 *
 * Example:
 *    const TEST = new RegExp(EMAIL)
*/

// tslint:disable-next-line:max-line-length
export const EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/*
 * This is MLP email double @ Regular Expression.
 *
 * Usage:
 *    import { DOUBLEAT } from './validators.expressions';
 *
 * Example:
 *    const TEST = new RegExp(DOUBLEAT)
*/

export const DOUBLEAT = /^@$/g;

/*
 * This is MLP phone number Regular Expression.
 *
 * Usage:
 *    import { PHONENUMBER } from './validators.expressions';
 *
 * Example:
 *    const TEST = new RegExp(PHONENUMBER)
*/

export const PHONENUMBER = /^[(]?(\+[\d]{1,3}\s?)?[\d ()]{7,}$/g;
